export function getCategoryFacetSetInitialState() {
    return {};
}
